import type { ReactElement, ReactNode } from "react";

type Props = Readonly<{
  minHeight?: number | string;
  children: ReactNode;
  testId?: string;
}>;

export default function StickyContainer({
  minHeight,
  children,
  testId,
}: Props): ReactElement {
  return (
    <div
      data-testid={testId}
      className="relative flex flex-col"
      style={{ minHeight: minHeight ? minHeight : "80vh" }}
    >
      {children}
    </div>
  );
}
